

import React from 'react';
import validate from './validation';
import './resetPassword.css';
import { MyTicket_PATH } from '../../../../AppConfig'
import RenderField from '../../../../Components/Fields/fields';
import Inputs from './inputSetting';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form'
import String from "../../../../Assets/Localization/local"
import { Link, Redirect } from "react-router-dom";
import { newpassword } from '../../../../Redux/Action/ForgetAction'
import logoPart1 from '../../../../Assets/Images/logoWihte.png'
import {
  Container,
  Row,
  Form,
  
} from 'reactstrap';
class NewPassword extends React.Component {
  constructor() {
    super();
    this.state = {
    };
  }
  onSubmit = (values) => {
    let data = {};
    data.email = this.props.email;
    data.type = this.props.type;
    data.newPassword = values.newPassword;
    values.email = this.props.email;
    this.props.newpassword(data, this.props.lang);
  }

  render() {
    const { handleSubmit } = this.props
    String.setLanguage(this.props.lang)
    if (this.props.page === 'Dashboard') {
      return <Redirect to={`${MyTicket_PATH}MyTicket/Dashboard`} />
    }
    return (
      <div className="loginClass" style={{ textAlign: 'center', color: 'white' }}>
         <div className="loginClass-2">
        <div className="OverLay">
          <div className="LoginContainer">
            <div className="LoginForm" >
              <img alt="part_one" src={logoPart1} className="img-fluid LogoPartt1Login" style={{margin:'0 auto', width: '60px', height: '60px' }} />
               <Form onSubmit={handleSubmit(this.onSubmit.bind(this))} className="FormContent">
                {
                  Inputs.map((row, index) => {
                    return (
                      <Container className="w-100">
                        <Row>
                          {
                            row.map((element, index) => {
                              return (

                                <div id="login" className={this.props.lang === "ar" ? "m-auto col-lg-12 col-md-12 arLang p-0  " : "m-auto col-lg-12 col-md-12  enLang "} >
                                  <Field
                                    type={element.type}
                                    lang={this.props.lang}
                                    name={element.name}
                                    placeholder={this.props.lang === 'en' ? element.placeholder.en : element.placeholder.ar}
                                    component={RenderField}
                                    icone={element.icon}
                                    loginBool={element.loginBool}
                                    label={element.label}
                                  />
                                </div>
                              )
                            })
                          }
                        </Row>
                      </Container>
                    )
                  })
                }

                <button type="submit" onClick={this.onSubmit} value="Login" className="loginBtn px-5">{String.SendKey} </button>
                <Link to={'/MyTicket/admin-login'} className="BackLink">{String.BackBtn}</Link>

              </Form>
            </div>
          </div>
        </div>
        </div>
      </div >
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    newpassword

  }, dispatch
)
const mapStateToProps = state => {
  return {
    email: state.forgetPass.email,
    type: state.forgetPass.type,
    lang: state.userInfo.language,
    token: state.userInfo.token,
    page: state.forgetPass.page,

  }
}
export default reduxForm({
  form: 'NewPassword',
  validate

})(connect(mapStateToProps, mapDispatchToProps)(NewPassword));
